
import { reactive, computed ,watch } from 'vue';
import Button from '../../../components/ui/button/index.vue';
import CardInfo from '../../../components/ui/cardinfo/index.vue';
import {useI18n} from 'vue-i18n';

export default {
  name: 'contentgroup',
  components: {
    Button,
    CardInfo
  },
  props: {
    titleType: {
      type: String,
      default: 'Group',
      required: false,
    },
    date: {
      type: String,
      default: '2020/05/09',
      required: false,
    },
    status: {
      type: Array,
      required: false,
      default: [
        {
          title: '__g3p_m8t.__online',
          key: 'device_online_count',
        },
        {
          title: '__g3p_m8t.__offline',
          key: 'device_offline_count',
        },
      ],
    },
    column: {
      type: Array,
      required: false,
      default: [
        {
          title: '__common.__model',
          key: 'model',
        },
        {
          title: '__g3p_m8t.__deviceAmount',
          key: 'device_count',
        },
        {
          title: '__d7d_n17r.__connectionStatus',
          key: 'connectionsStatus',
        }
      ],
    },
    settingMenu: {
      type: Array,
      required: false,
      default: [
        {
          title: 'Add device',
          key: 'addDevice',
          group: 1,
          isI18n : '__d7d_n17r.__addDevice',
        },
        {
          title: 'Rename group name',
          key: 'renameGroupName',
          group: 1,
          isI18n : '__d7d_n17r.__renameGroupName',
        },
        {
          title: 'Ungroup only',
          key: 'unGroupOnly',
          group: 2,
          isI18n : '__g3p_m8t.__ungroupOnly',
        },
        {
          title: 'Ungroup and unbind devices',
          key: 'unGroupAndUnbindAll',
          group: 2,
          isI18n : '__g3p_m8t.__ungroupAndUnbindDevices',
        }
      ],
    },
    data: {
      type: [Object, Array],
      required: false,
      default:
      {
        model: 'PA329QTC',
        device_count: 250,
        connectionsStatus:{
          device_online_count: 135,
          device_offline_count: 115,
        }
        
      }
      ,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const { data } = props;
    const state = reactive({
      modal: false,
      myData: data
    })


    const statusData = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__online'),
          key: 'device_online_count',
        },
        {
          title: t('__g3p_m8t.__offline'),
          key: 'device_offline_count',
        },
      ]
    })

    watch(
      () => props.data,
      (val) => {
        state.myData = val;
        // state.myData.model = null
        for (const key in state.myData) {
          if (state.myData[key] == null) {
            state.myData[key]  = ' '
          }
        }
      },
      {deep: true}
    )

    const openMenu = () => {
      state.modal = !state.modal;
      
    }

    const menuSettingSelect = (e) => {
      emit('menuSetting', e)
      state.modal = false;
    }

    const fulfill = computed(() => {
      let intArr = Array.from(String(state.myData.device_count));
      let max = 5
      let newArr = [];
      if (intArr.length < max) {
        for (let i = 0; i < (max - intArr.length); i++) {
          newArr.push(0)
        }
      }
      return newArr
    })

    const handleFocusOut = () => {
      state.modal = false
    }

    return {
      state,
      openMenu,
      menuSettingSelect,
      handleFocusOut,
      fulfill,
      t,
      statusData
    }
  }// end: setup

}